import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/common/ui/Button";
import {
  NumberInput,
  RadioInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import { history } from "../../_helpers";
import React, { useEffect, useState } from "react";
import { eCardCategorySchema } from "../../validation/eCardSchema";
import { eCardAction } from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { useLocation } from "react-router-dom";
import CustomLoader from "../../components/common/ui/Loader";
import { getStoredValue } from "../../_helpers/storagehelper";

function AddOrEditECardCategory() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { monthList, Status } = useSelector((x) => x?.dropdownOptions);
  const { categoryDetail, loading } = useSelector((x) => x?.ecard);

  const [errorMessage, setErrorMessage] = useState({});
  const [createCategoryData, setCreateCategoryData] = useState({
    categoryId: 0,
    categoryName: "",
    fromMonth: 0,
    toMonth: 0,
    monthRange: "",
    costCategory: "",
    isActive: 1,
    createdBy: getStoredValue("user")?.ManagementUserID || 0,
  });

  const CategoryId = location?.state?.CategoryId
    ? location?.state?.CategoryId
    : 0;

  useEffect(() => {
    //get details for edit
    dispatch(eCardAction?.resetCategoryDetail());
    if (CategoryId === 0) return;
    const requestData = { ...createCategoryData };
    requestData.categoryId = CategoryId;
    setCreateCategoryData(requestData);
    dispatch(eCardAction?.getEcardCategoryDetails(CategoryId))
      .then((result) => {
        const categoryDetail = result?.payload;
        if (categoryDetail) {
          setCreateCategoryData((prevState) => ({
            ...prevState,
            categoryId: categoryDetail?.CategoryId,
            categoryName: categoryDetail?.CategoryName,
            fromMonth: parseInt(categoryDetail?.FromMonth),
            toMonth: parseInt(categoryDetail?.ToMonth),
            monthRange: categoryDetail?.MonthRange,
            // costCategory:
            //   categoryDetail?.CostCategory !== null
            //     ? categoryDetail?.CostCategory
            //     : "",
            costCategory:
              categoryDetail?.CostCategory !== null
                ? categoryDetail?.CostCategory.toFixed(2)
                : "",
            isActive: categoryDetail?.IsActive === 1 ? 1 : 0,
          }));
        }
      })
      .catch((err) => {
        showToastNotification("Failed to get E-Card Category details", "error");
      });
  }, [CategoryId]);

  const showToasterMessage = (response) => {
    switch (response?.IsSucceed) {
      case 1:
        showToastNotification(
          "E-Card Category created successfully",
          "success"
        );
        history.navigate("/Admin/E-Cards/Category");
        break;

      case 2:
        showToastNotification(
          "E-Card Category updated successfully",
          "success"
        );
        history.navigate("/Admin/E-Cards/Category");
        break;

      case -2:
        showToastNotification("E-Card Category Name Already exist", "warning");
        break;

      default:
        break;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value.startsWith(" ")) return;
    const isValid = /^[a-zA-Z0-9. ']*$/.test(value);
    if (!isValid) return;
    // if (name === "costCategory") {
    //   const regex = /^\d*\.?\d*$/;
    //   // const regex = /^(\d+(\.\d*)?|\.\d*)$/;
    //   if (!regex.test(value)) return;
    // }

    // const costAmount =
    //   name === "costCategory" && value !== "" ? parseInt(value) : 0;

    setCreateCategoryData((prevState) => ({
      ...prevState,
      [name]: name === "isActive" ? parseInt(value) : value,
      ...(name === "costCategory" && {
        costCategory: value === null || value === "" ? "" : parseFloat(value),
      }),
    }));
  };

  const handleMonthChange = (e, input) => {
    const data = { ...createCategoryData };
    data[input] = e?.value !== undefined ? e?.value : 0;
    const monthRange = createMonthRange(
      data?.fromMonth ? data?.fromMonth : 1,
      data?.toMonth ? data?.toMonth : 12
    );
    data["monthRange"] = monthRange.toString();
    setCreateCategoryData(data);
    const error = { ...errorMessage };

    if (e?.value > 0) {
      error[input] = "";
      setErrorMessage(error);
    }
    return;
  };

  function createMonthRange(from, to) {
    const range = [];
    let current = from;

    while (true) {
      range.push(current);
      if (current === to) break;
      current = (current % 12) + 1;
    }

    return range;
  }

  const handleFormSubmit = (e) => {
    e?.preventDefault();
    const requestData = { ...createCategoryData };
    requestData["costCategory"] =
      requestData?.costCategory === null || requestData?.costCategory === ""
        ? 0
        : requestData?.costCategory;
    // setCreateCategoryData(requestData);
    const { error } = eCardCategorySchema(requestData);

    if (error?.details) {
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }
    // const payload = { ...createCategoryData };
    requestData["createdBy"] =
      getStoredValue("user")?.ManagementUserID || 0;
    dispatch(eCardAction?.createEcardCategory(requestData))
      .then((result) => {
        if (result?.payload) {
          showToasterMessage(result?.payload);
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create E-Card Category", "error");
      });
  };

  const handleValidation = (e, name) => {
    const requestData = { ...createCategoryData };
    requestData["costCategory"] =
      requestData?.costCategory === null || requestData?.costCategory === ""
        ? 0
        : requestData?.costCategory;


    const { error } = eCardCategorySchema(requestData);
    if (error?.details) {
      const fieldError = error.details.find((e) => e.path.toString() === name);
      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "",
      }));
      return;
    }
    const fieldError = error?.details?.find(
      (e) => e?.path?.toString() === name
    );
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      if (fieldError) {
        element.classList.add("input-error");
      } else {
        element.classList.remove("input-error");
      }
    }
  };

  const handleReset = () => {
    setErrorMessage({});
    const data = {
      categoryId: categoryDetail?.CategoryId,
      categoryName: categoryDetail?.CategoryName
        ? categoryDetail?.CategoryName
        : "",
      fromMonth: categoryDetail?.FromMonth
        ? parseInt(categoryDetail?.FromMonth)
        : 0,
      toMonth: categoryDetail?.ToMonth ? parseInt(categoryDetail?.ToMonth) : 0,
      monthRange: categoryDetail?.MonthRange ? categoryDetail?.MonthRange : "",

      costCategory: categoryDetail?.CostCategory
        ? categoryDetail?.CostCategory
        : "",
      isActive:
        Object?.keys(categoryDetail)?.length > 0 &&
          categoryDetail?.IsActive === 1
          ? 1
          : Object?.keys(categoryDetail)?.length > 0 &&
            categoryDetail?.IsActive === 0
            ? 0
            : 1,
    };
    setCreateCategoryData(data);
  };

  if (loading) return <CustomLoader />;

  return (
    <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100">
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <h2 className=" mb-4 text-color">
          {CategoryId === 0 ? "ADD" : "EDIT"} E-CARD CATEGORY
        </h2>
        <Button
          label="Back"
          type="button"
          icon={"fa-solid fa-angle-left"}
          status="primary"
          onClick={() => {
            history.navigate("/Admin/E-Cards/Category", {
              state: {
                CategoryId: 0,
              },
            });
          }}
        />
      </div>
      <form onSubmit={(e) => handleFormSubmit(e)}>
        <div className="d-flex flex-wrap flex-column ">
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-4">
              <div className="form-floating mb-3">
                <TextInput
                  name="categoryName"
                  label="Category Name"
                  placeholder="Enter Category Name"
                  maxLength={50}
                  value={createCategoryData.categoryName}
                  handleChange={(e) => {
                    handleChange(e);
                  }}
                  required
                  errorMessage={errorMessage}
                  handleBlur={(e) => {
                    handleValidation(e, "categoryName");
                  }}
                />
              </div>
            </div>

            <div className="col-sm-6 col-md-6 col-lg-4">
              <SelectInput
                name="fromMonth"
                options={monthList}
                closeMenuOnSelect={true}
                isLoading={false}
                label="Start Month"
                placeholder="Select Month"
                handleChange={(e) => {
                  handleMonthChange(e, "fromMonth");
                }}
                isClearable={createCategoryData?.fromMonth !== 0}
                value={createCategoryData?.fromMonth}
                required
                errorMessage={errorMessage}
                handleBlur={(e) => {
                  handleValidation(e, "fromMonth");
                }}
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-4">
              <SelectInput
                name="toMonth"
                options={monthList}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                label="End Month"
                placeholder="Select Month"
                isClearable={createCategoryData?.toMonth !== 0}
                handleChange={(e) => {
                  handleMonthChange(e, "toMonth");
                }}
                value={createCategoryData?.toMonth}
                required
                errorMessage={errorMessage}
                handleBlur={(e) => {
                  handleValidation(e, "toMonth");
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-4">
              <div className="form-floating mb-3">
                <NumberInput
                  label="Category Cost($)"
                  name="costCategory"
                  placeholder="1.00"
                  handleChange={(e) => {
                    handleChange(e);
                  }}
                  // value={
                  //   createCategoryData.costCategory > 0.05
                  //     ? createCategoryData.costCategory
                  //     : ""
                  // }
                  value={
                    createCategoryData.costCategory === null
                      ? ""
                      : createCategoryData.costCategory
                  }
                  maxLength={5}
                  // required
                  errorMessage={errorMessage}
                  handleBlur={(e) => {
                    handleValidation(e, "costCategory");
                  }}
                  maxValue={99}
                />
              </div>
            </div>

            <div className="col-sm-6 col-md-6 col-lg-4">
              <RadioInput
                label="Status"
                name="isActive"
                id="isActive"
                options={Status}
                selectedValue={createCategoryData.isActive}
                handleChange={(e) => {
                  handleChange(e);
                }}
              // required
              />
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap mt-3 mb-5">
          <Button
            variant="primary"
            className="me-2"
            label={`${CategoryId ? "Update" : "Save"}`}
            type="submit"
            status="success"
            icon={"fa-solid fa-floppy-disk"}
          />

          <Button
            variant="secondary"
            className="me-2"
            label="RESET"
            type="button"
            status="secondary"
            disabled={false}
            icon="fa-solid fa-rotate-right"
            onClick={() => {
              handleReset();
            }}
          />
        </div>
      </form>
    </div>
  );
}

export default React.memo(AddOrEditECardCategory);
